var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('SendGiftMenu',{attrs:{"header":"Shipping","back-to":"ShoppingBag","display-stepper":true}}),_c('RecipientForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }